import { KeyValueLabel, NoValue } from '@tribeauto/ngx-mobilite-material';
import { AvailableSellerResponse } from '../../shared/pages/records/records.component.model';
import { TranslateService } from '@ngx-translate/core';

export const sellerAll: KeyValueLabel = { key: 'all', value: 'all', label: 'application.records.all' };

export const sellersToKeyValueLabelsWithAllOption = (
  availableSellerResponseList: AvailableSellerResponse[],
  translateService: TranslateService
): KeyValueLabel[] => {
  if (availableSellerResponseList.length) {
    if (
      availableSellerResponseList.length > 1 &&
      !availableSellerResponseList.some(seller => seller.firstName === sellerAll.label)
    ) {
      availableSellerResponseList.unshift({
        firstName: sellerAll.label!,
        jossoLogin: sellerAll.value,
        lastName: ''
      });
    }
    return availableSellerResponseList.map(seller => ({
      key: seller.jossoLogin,
      value: seller.jossoLogin,
      label:
        seller.firstName === sellerAll.label
          ? translateService.instant(seller.firstName)
          : `${seller.firstName} ${seller.lastName}`
    }));
  }
  return [];
};

export const areEqualsKeyValue = (kvl1: KeyValueLabel | NoValue, kvl2: KeyValueLabel | NoValue): boolean => {
  return (
    (kvl1 === null && kvl2 === null) ||
    (kvl1 === undefined && kvl2 === undefined) ||
    (!!kvl1 && !!kvl2 && kvl1.key === kvl2.key && kvl1.value === kvl2.value)
  );
};
